document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-faq .faq-item").forEach(function (item) {
    const question = item.querySelector(".faq-question");
    if (!question) return;

    question.addEventListener("click", function () {
      const wasActive = item.classList.contains("active");

      const section = item.closest(".product-faq-section");

      if (section && section.dataset.accordionMode === "true" && !wasActive) {
        section.querySelectorAll(".faq-item").forEach(function (other) {
          other.classList.remove("active");
        });
      }

      item.classList.toggle("active", !wasActive);
    });
  });
});